<template>
    <v-container>
        <v-row
            class="mt-5"
            no-gutters
        >
            <v-col
                cols="12"
            >
                <v-row
                    justify="center"
                    no-gutters
                >
                    <v-text-field
                        v-model="accountInfo.street_address"
                        label="Street"
                        outlined
                        class="px-5 mt-3 mb-0 py-0"
                        :disabled="accountInfo.account_status == 'canceled'"
                        v-on:input="unsavedChange = true"
                        @keydown.enter="updateAccountAddress"
                    />
                    <v-row
                        class="align-content-center"
                        no-gutters
                    >
                        <v-col
                            class="mx-5 my-0 py-0 d-flex flex-nowrap"
                        >
                            <v-col
                                cols="6"
                                class="ma-0 pa-0"
                            >
                                <v-text-field
                                    v-model="accountInfo.city"
                                    label="City"
                                    outlined
                                    class="mr-2 my-0 py-0"
                                    :disabled="accountInfo.account_status == 'canceled'"
                                    v-on:input="unsavedChange = true"
                                    @keydown.enter="updateAccountAddress"
                                />
                            </v-col>
                            <v-col
                                cols="3"
                                class="ma-0 pa-0"
                            >
                                <v-text-field
                                    cols="2"
                                    v-model="accountInfo.state"
                                    label="State"
                                    outlined
                                    class="mr-2 my-0 py-0"
                                    :disabled="accountInfo.account_status == 'canceled'"
                                    v-on:input="unsavedChange = true"
                                    @keydown.enter="updateAccountAddress"
                                />
                            </v-col>
                            <v-col
                                cols="3"
                                class="ma-0 pa-0 my-0 py-0"
                            >
                                <v-text-field
                                    cols="2"
                                    v-model="accountInfo.zip"
                                    label="Zip"
                                    outlined
                                    class="my-0 py-0"
                                    :disabled="accountInfo.account_status == 'canceled'"
                                    v-on:input="unsavedChange = true"
                                    @keydown.enter="updateAccountAddress"
                                />
                            </v-col>
                        </v-col>
                    </v-row>
                    <v-row
                        v-if="unsavedChange"
                        class="mx-5 mb-6"
                        justify="end"
                        no-gutters
                    >
                        <v-btn
                            color="info"
                            @click.prevent="updateAccountAddress"
                        >
                            Save Address
                        </v-btn>
                    </v-row>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'credentials',

    data: () => ({
        show: false,
        unsavedChange: false,
    }),

    methods: {
        updateAccountAddress() {
            if(
                this.accountInfo.street_address != null &
                this.accountInfo.street_address != '' &
                this.accountInfo.city != null &
                this.accountInfo.city != '' &
                this.accountInfo.state != null &
                this.accountInfo.state != '' &
                this.accountInfo.zip != null &
                this.accountInfo.zip != ''
            ) {
                this.$store.dispatch('data/updateAccountAddress',[this.accountInfo.street_address,this.accountInfo.city, this.accountInfo.state,this.accountInfo.zip]);
                this.unsavedChange = false;
            }
        },

    },

    computed: {
        accountInfo() {
            return this.$store.getters['data/account'];
        },

    } 
};
</script>
